<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv5">
          <!-- <el-checkbox
              v-model="checkAll"
              class="select-doc margin-left-10"
            /> -->
          <span class="stt padding-left-10">STT</span>
        </div>
        <div
          class="theTitle theTitle__lv1 flex-row flex__left padding-left-10"
          @click="doSort('quote')"
        >
          Trích yếu
          <sort-caret :order="order" :sort="sort" :field="'quote'"/>
        </div>
      </div>
      <div class="rightSection flex-row flex__right">
        <div
          class="theTitle theTitle__lv2 flex-row flex__left padding-left-10"
          @click="doSort('status')"
        >
          Trạng thái
          <sort-caret :order="order" :sort="sort" :field="'status'"/>
        </div>
        <div
          class="theTitle theTitle__lv3 flex-row flex__left padding-left-10"
          @click="doSort('senderFullName')"
        >
          Người chuyển
          <sort-caret :order="order" :sort="sort" :field="'senderFullName'"/>
        </div>
        <div
          class="theTitle theTitle__lv3 flex-row flex__left padding-left-10"
          @click="doSort('senderFullName')"
        >
          Thời gian xử lý
          <sort-caret :order="order" :sort="sort" :field="'senderFullName'"/>
        </div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="perfectScrollbarSetting"
      infinite-wrapper
    >
      <div class="list-docs">
        <div
          v-for="(item, $itemIndex) in outgoingDocs"
          v-bind:key="$itemIndex"
          class="item flex-row flex__between"
          @click="viewDetail(item)"
        >
          <div class="leftSection flex-row flex__left clickable">
            <div class="theTitle__lv5">
              <div class="flex-row flex__left">
                <div class="section-check">
                  <span class="stt flex-row flex__center">{{
                    $itemIndex + 1
                  }}</span>
                </div>
                <i
                  class="fas fa-file color__smoke"
                  @click.stop="
                    downloadAttachment(item, ATTACHMENT_OBJECT_TYPE.VB_DI)
                  "
                ></i>
              </div>
            </div>
            <div class="theTitle__lv1 margin-right-10 padding-left-10">
              <div class="title-docs flex-col flex__left">
                <div class="tt_1 clickable" v-bind:class="textBold(item)">
                  {{ item.quote }}
                </div>
                <div class="tt_2 flex-row flex__left margin-top-10">
                  <span v-if="item.docCode"
                  >#{{ item.docCode }}&nbsp;&nbsp;</span
                  >
                  <el-tag
                    v-if="item.docTypeName"
                    size="mini"
                    :class="['priority', 'lv3']"
                  >{{ item.docTypeName }}
                  </el-tag>

                  <el-tag
                    v-if="isShowPriority(item.priorityId)"
                    size="mini"
                    :class="['priority', getPiorityClass(item.priorityId)]"
                  >
                    <img
                      src="@/assets/img/new-symbol/zap.svg"
                      alt=""
                      class="icon-very__small"
                    />
                    <span>
                      {{ item.priorityName }}
                    </span>
                  </el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="rightSection flex-row flex__right">
            <div
              class="theTitle__lv2 flex-row flex__left padding-left-10 font-size__small"
            >
              <div
                :class="[
                  'status-doc flex-row flex__left font-size__medium',
                  item.status == 0
                    ? 'TAOMOI'
                    : item.status == 1
                    ? 'DANGTRINHKY'
                    : item.status == 4
                    ? 'CHOBANHANH'
                    : item.status == 6
                    ? 'TUCHOI'
                    : 'TUCHOI'
                ]"
              >
                &nbsp;&nbsp;
                <filterIconByStatus :status="item.status"/>
                <span
                >&nbsp;&nbsp;{{
                    getStatusLabel(item.status)
                  }}&nbsp;&nbsp;</span
                >
              </div>
            </div>
            <div
              class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
            >
              <div class="flex-row flex__right">
                {{ item.senderFullName || "-" }}
              </div>
            </div>
            <div class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small">
              <div class="flex-row flex__right">
                {{item.createTime |
                dateFormatter({nullValue: "-"})}}
              </div>
            </div>
          </div>
        </div>

        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          @infinite="infiniteHandler"
          force-use-infinite-wrapper=".el-table__body-wrapper"
        >
          <div slot="no-more"></div>
          <div slot="no-results">Không tìm thấy kết quả nào</div>
        </infinite-loading>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
  import dateFormatter from "../../filters/dateFormatter";
  import SortCaret from "./SortCaret";
  import mainContentMixin from "./mainContentMixin";

  export default {
    name: "main-content-uyquyen",
    components: {
      SortCaret,
      infiniteLoading: () => import("vue-infinite-loading"),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
      filterIconByStatus: () => import("../common/filterIconStatusVban.vue")
    },
    filters: {dateFormatter},
    mixins: [mainContentMixin]
  };
</script>



// WEBPACK FOOTER //
// src/views/doc-out/mainContentUyQuyen.vue